jQuery(document).ready(function($) {
    var thumbnails = $('.gallery-thumbnail');
    var mainImage = $('.woocommerce-product-gallery__image img');
    var currentIndex = 0; // Keep track of the current thumbnail index

    // Function to update the main image according to the current thumbnail
    function updateMainImage() {
        var image_full = $(thumbnails[currentIndex]).data('image-full');
        mainImage.attr('src', image_full);
    }

    // Click event on thumbnails
    thumbnails.on('click', function() {
        currentIndex = thumbnails.index(this);
        updateMainImage();
        thumbnails.removeClass('active');
        $(this).addClass('active');
    });

    // Click event for the prev arrow
    $('.prev-arrow').on('click', function() {
        if (currentIndex > 0) {
            currentIndex--;
        } else {
            currentIndex = thumbnails.length - 1; // Go to the last if we're at the first item
        }
        updateMainImage();
        thumbnails.removeClass('active').eq(currentIndex).addClass('active');
    });

    // Click event for the next arrow
    $('.next-arrow').on('click', function() {
        if (currentIndex < thumbnails.length - 1) {
            currentIndex++;
        } else {
            currentIndex = 0; // Go to the first if we're at the last item
        }
        updateMainImage();
        thumbnails.removeClass('active').eq(currentIndex).addClass('active');
    });

    // Initialize the gallery with the first image
    updateMainImage();
    thumbnails.first().addClass('active');
});
